import { Box, Typography } from "@mui/material";

const CustomUnclickableOverviewCard = ({ icon, text, number, iconElement }) => {
  return (
    <Box
      sx={{
        borderRadius: "8px",
        backgroundColor: (theme) => theme.palette.mode === "dark" ? "#1e1e1e" : "#fff",
        padding: "1.5em",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        border: (theme) => `1px solid ${theme.palette.mode === "dark" ? "#333" : "#E5E7EB"}`,
      }}
    >
      <Box sx={{ mb: 1, width: "3em", display: "flex", justifyContent: "center", alignItems: "center" }}>
        {iconElement
          ? iconElement
          : <img src={icon} alt="" style={{ width: "100%" }} />}
      </Box>
      <Typography variant="body2" sx={{ fontSize: "1rem", fontWeight: 500, mb: 0.5 }}>
        {text}
      </Typography>
      <Typography variant="h6" sx={{ fontWeight: 700, color: "primary.safeOnLight" }}>
        {number}
      </Typography>
    </Box>
  );
};

export default CustomUnclickableOverviewCard;
